import React, { useEffect, useState } from 'react';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { RadioButton } from 'react-native-paper';
import PropTypes from 'prop-types';

import LocationSelectionMap from './LocationSelectionMap';

import getStations from './map-assets/stations';

const stations = getStations();

function getStationName(stationKey) {
  const station = stations.find(({ key }) => key === stationKey);
  if (station) {
    return station.title;
  } else {
    return '';
  }
}

export default function LocationSelection({
  actions,
  pageContent,
  toggleDisableNextStep,
}) {
  const { setFieldValue, setFieldTouched, touched, values, errors } = actions;
  const [unit, setUnit] = useState('ha');

  useEffect(() => {
    if (
      (errors.weatherStation && touched.weatherStation) ||
      !touched.weatherStation ||
      (errors.soilCode && touched.soilCode) ||
      !touched.soilCode
    ) {
      toggleDisableNextStep(true);
    } else {
      toggleDisableNextStep(false);
    }
  }, [errors, touched]);

  function updateSelectedStation(station) {
    setFieldValue('weatherStation', station);
    setFieldTouched('weatherStation', true);

    // reset crops array when weather station changed to or from pampa de majes
    if (values.crops.length > 0) {
      setFieldValue('crops', []);
    }
  }

  function updateSelectedSoil(soil) {
    setFieldValue('soilCode', soil);
    setFieldTouched('soilCode', true);
  }

  function updateUserCoords(location) {
    setFieldValue('userCoords', location);
    setFieldTouched('userCoords', true);
  }

  return (
    <View style={styles.container}>
      <LocationSelectionMap
        stations={stations}
        updateSelectedStation={updateSelectedStation}
        updateSelectedSoil={updateSelectedSoil}
        updateUserCoords={updateUserCoords}
        userCoords={values.userCoords}
      />
      <Text>
        {pageContent[0]}:{' '}
        {values.weatherStation ? getStationName(values.weatherStation) : ''}
      </Text>
      <Text style={styles.textInput}>{pageContent[1]}</Text>
      <RadioButton.Group
        onValueChange={(unitSelection) => {
          setUnit(unitSelection);
          setFieldValue('unit', unitSelection);
          setFieldTouched('unit', true);
        }}
        value={unit}
      >
        <View style={styles.radioContainer}>
          <RadioButton value="ha" />
          <Text>ha</Text>
        </View>
        <View style={styles.radioContainer}>
          <RadioButton value="topos" />
          <Text>topos</Text>
        </View>
      </RadioButton.Group>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  radioContainer: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  textInput: {
    marginTop: 15,
  },
});

LocationSelection.propTypes = {
  actions: PropTypes.shape({
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
    touched: PropTypes.object,
    values: PropTypes.object,
    errors: PropTypes.object,
  }),
  pageContent: PropTypes.array,
  toggleDisableNextStep: PropTypes.func,
};
